/**
 * Created by Xiaotao.Nie on 26/01/2018.
 * All right reserved
 * IF you have any question please email onlythen@yeah.net
 */

// import TimeLine from './components/TimeLine'

var TimeLine = require('./components/TimeLine')

module.exports = TimeLine
// export default TimeLine



// WEBPACK FOOTER //
// ./src/index.js